import { styled } from "@mui/material/styles";
import { Typography, Button } from "@mui/material";

export const Info = styled(Typography)(({ theme }) => ({
  marginBottom: 20,
  [theme.breakpoints.up("tablet")]: {
    marginBottom: 40,
  },
}));

export const StyledButton = styled(Button)(({ theme }) => ({
  width: 200,
  fontSize: theme.typography.pxToRem(14),
  height: 43,
  marginBottom: 54,
  borderRadius: 100,
  [theme.breakpoints.up("mobile")]: {
    width: 280,
    fontSize: theme.typography.pxToRem(20),
    height: 60,
    marginBottom: 81,
  },
  [theme.breakpoints.up("tablet")]: {
    width: 350,
    fontSize: theme.typography.pxToRem(25),
    height: 75,
    marginBottom: 96,
  },
}));
